import React, { Fragment } from "react"
import { RouteComponentProps } from "@reach/router"
import { Navigation } from "../../components"
import styles from "./AboutUs.scss"

const AboutUsPage = ({  }: RouteComponentProps) => (
  <Fragment>
    <Navigation animated={false} />
    <div className={styles.container}>
      <h1>NOTRE HISTOIRE</h1>
      <hr />
      <p>
        Allez Go ! a été crée pour répondre aux besoins souhaités de pouvoir
        expérimenter de nouvelles formes d’activités, de loisirs, et de sorties
        aux multiples facettes. Corinne et Mickael, les deux fondateurs, curieux
        d’activités, de cours et de sorties variées ont souvent constaté le
        manque d’interactions entre les personnes lors de ces moments.
        <br />
        <br /> L’équipe d’Allez Go ! voit alors l’opportunité de repenser les
        activités de loisirs et de sorties de petits groupes, en expériences
        agrégeant la rencontre, l’échange, le moment unique et la mixité au sein
        du groupe. Nous pensons qu’en connectant les gens passionnés, prêts à
        partager leurs passions, leur compétences ou leurs expertises avec ceux
        qui souhaitent faire de leur temps libre un moment authentique, nous
        favorisons l’émergence de nouvelles expériences qui font sens dans notre
        société.
        <br />
        <br /> Parce que susciter l’émotion est notre vocation.
      </p>
    </div>
  </Fragment>
)

export default AboutUsPage
